/**
 * Prefixo sob o qual a aplicação está servida.
 *
 * Vem do `base` do Vite (`import.meta.env.BASE_URL`), definido em build por
 * `VITE_BASE`. Na raiz do domínio vale `''`; sob um prefixo, `/stratumtech`.
 *
 * Sempre **sem** barra final, para concatenar como `${basePath}/api` sem
 * produzir barra dupla.
 *
 * Isto existe porque o navegador é quem monta essas URLs: mesmo que o nginx
 * remova o prefixo antes de chegar ao backend, a requisição sai do navegador
 * com ele. Um `fetch('/api/...')` cru iria para a raiz do domínio e escaparia
 * do bloco de proxy.
 */
export const basePath = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '')

/** `''` → `/api`; `/stratumtech` → `/stratumtech/api`. */
export const withBase = (path: string) =>
  `${basePath}/${path.replace(/^\/+/, '')}`
